import {
    Stack,
    Typography,
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {
    currencies,
    deliveryFormats,
    deliveryTypes,
} from "../../utils/enums";
import HighlightPanel from "../../components/HighlightPanel";
import DeviceData from "./newOrder/DeviceData";
import FinancialData from "./newOrder/FinancialData";
import ReturnData from "./newOrder/ReturnData";
import GeneralData from "./newOrder/GeneralData";
import DeliveryData from "./newOrder/DeliveryData";
import {useConfig} from "../../context/ConfigContext";
import orderRules from "./orderRules";


const OrderForm = ({generalRef, deliveryRef, deviceRef, returnRef, financialRef, order}) => {
    const oneWeekLater = Date.now() + 7 * 24 * 60 * 60 * 1000;
    const general = {
        internal_comment: order?.internal_comment || '',
        ordered_by: order?.ordered_by || null,
        tour_office: order?.tour_office || null,
        contact_person: order?.contact_person || null,
        tour_guide: order?.tour_guide || null,
        usage_country: order?.usage_country || 'HU',
        delivery_date: new Date(order?.delivery_date || Date.now()),
        return_date: new Date(order?.return_date || oneWeekLater)
    }

    const delivery = {
        delivery_format: order?.delivery_format || deliveryFormats.Case,
        delivery_address: order?.delivery_address || {
            address_com: '',
            coordinates: {lat: 47.4979, lng: 19.0402},
            address: ''
        },
        delivery_type: order?.delivery_type || deliveryTypes.HAND,
        delivery_courier_new: order?.delivery_courier_new || '',
        delivery_time: order?.delivery_time?.slice(0, 5) || null,
        delivery_period: order?.delivery_period || '',
        actual_delivery_date: new Date(order?.actual_delivery_date || Date.now()),
        delivery_time_set: order?.delivery_time_set || false,
        delivery_comment: order?.delivery_comment || '',
    };

    const device = {
        order_rx: order?.order_rx || '',
        order_tx: order?.order_tx || ''
    };

    const returning = {
        return_type: order?.return_type || deliveryTypes.HAND,
        return_courier_new: order?.return_courier_new || '',
        return_address: order?.return_address || {
            address_com: '',
            coordinates: {lat: 47.4979, lng: 19.0402},
            address: ''
        },
        return_time: order?.return_time?.slice(0, 5) || null,
        return_period: order?.return_period || '',
        actual_return_date: new Date(order?.actual_return_date || oneWeekLater),
        return_time_set: order?.return_time_set || false,
        return_comment: order?.return_comment || '',
    };

    const financial = {
        agreed_price: order?.agreed_price || undefined,
        invoice: order?.invoice || '',
        currency: order?.currency || currencies.HUF,
        payed_amount: order?.payed_amount || null
    };

    const [formState, setFormState] = useState({
        ...(orderRules.canEditGeneral(order) ? general : {}),
        ...(orderRules.canEditDelivery(order) ? delivery : {}),
        ...(orderRules.canEditDelivery(order) ? device : {}),
        ...(orderRules.canEditReturn(order) ? returning : {}),
        ...financial,
    })
    const {
        generalColor,
        deliveryColor,
        deviceColor,
        returnColor,
        financialColor
    } = useConfig()

    return <Stack spacing={2}>
        <HighlightPanel color={generalColor}>
            <Typography variant="h6" gutterBottom>Általános infó</Typography>
            {orderRules.canEditGeneral(order) ? <GeneralData data={formState} setData={setFormState} reference={generalRef}/> : <Typography variant='body'>Ilyenkor már nem lehet általános adatot módosítani.</Typography>}
        </HighlightPanel>

        <HighlightPanel color={deliveryColor}>
            <Typography variant="h6" gutterBottom>Kiszállítás adatok</Typography>
            {orderRules.canEditDelivery(order) ? <DeliveryData data={formState} setData={setFormState} reference={deliveryRef}/> : <Typography variant='body'>Ilyenkor már nem lehet kiszállítási adatot módosítani.</Typography>}
        </HighlightPanel>

        <HighlightPanel color={deviceColor}>
            <Typography variant="h6" gutterBottom>Eszközök</Typography>
            {orderRules.canEditDelivery(order) ? <DeviceData data={formState} setData={setFormState} reference={deviceRef}/> : <Typography variant='body'>Ilyenkor már nem lehet eszköz adatot módosítani.</Typography>}
        </HighlightPanel>

        <HighlightPanel color={returnColor}>
            <Typography variant="h6" gutterBottom>Vissszaszállítás adatok</Typography>
            {orderRules.canEditReturn(order) ? <ReturnData data={formState} setData={setFormState} reference={returnRef}/> : <Typography variant='body'>Ilyenkor már nem lehet visszaszállítási adatot módosítani.</Typography>}
        </HighlightPanel>

        <HighlightPanel color={financialColor}>
            <Typography variant="h6" gutterBottom>Pénzügyi adatok</Typography>
            <FinancialData data={formState} setData={setFormState} reference={financialRef}/>
        </HighlightPanel>
    </Stack>
};

export default OrderForm;